import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Price from 'components/shared/Price'
import Button from 'components/shared/Button'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { SummaryProps } from './Summary.types'
import Info from 'components/shared/Info'
import { SummaryWrapper } from './Summary.styles'
import { Statements } from 'routes/Upsell/SpaCreator/fields/Statements'
import { useEffect, useState } from 'react'

const Summary = ({
    price,
    errorMessage,
    isDisabled,
    isLoading,
    onCancel,
    onSubmit,
}: SummaryProps) => {
    const { isTablet } = useResolutions()

    const [areStatementsAccepted, setAreStatementsAccepted] = useState(false)
    const [areStatementsError, setAreStatementsError] = useState(false)
    const [isStatementValidationTriggered, setIsStatementValidationTriggered] =
        useState(false)

    const handleAddSpa = () => {
        if (areStatementsAccepted) onSubmit()
        else setAreStatementsError(true)
    }
    const handleCancelSpa = () => onCancel()

    const handleAcceptingStatements = () => {
        setAreStatementsAccepted((last) => !last)
    }

    useEffect(() => {
        areStatementsAccepted && setAreStatementsError(false)
    }, [areStatementsAccepted])

    useEffect(() => {
        areStatementsError && setIsStatementValidationTriggered(true)
    }, [areStatementsError])

    return (
        <SummaryWrapper gap={[24, 40]} isFullWidth>
            <Statements
                isChecked={areStatementsAccepted}
                isError={areStatementsError}
                isHollowError={isStatementValidationTriggered}
                onChange={handleAcceptingStatements}
            />
            {!!errorMessage && (
                <Info color="error" variantType="warning">
                    {errorMessage}
                </Info>
            )}
            <Box
                direction={['column', 'row']}
                justify={['flex-end', 'space-between']}
                align={['stretch', 'center']}
                gap={[12, 16]}
                isFullWidth
            >
                {price !== undefined && (
                    <Box
                        direction="row"
                        justify={['flex-end', 'flex-start']}
                        align="baseline"
                        gap={4}
                    >
                        <Text variant="bodySmall" color="secondary_500">
                            <FormattedMessage
                                id="upsells.wellness.variant_price"
                                defaultMessage="Cena:"
                            />
                        </Text>
                        <Price value={price} size="heading2" />
                    </Box>
                )}
                <Box
                    direction="row"
                    justify="flex-end"
                    align="center"
                    gap={24}
                    isFullWidth
                >
                    <Text
                        as="button"
                        variant="bodyStrong"
                        color="grayscale_800"
                        onClick={isLoading ? undefined : handleCancelSpa}
                        data-testid="spa-button-cancel-edit"
                    >
                        <FormattedMessage
                            id="global.btn.cancel"
                            defaultMessage="Anuluj"
                        />
                    </Text>
                    <Button
                        variant="secondary"
                        width="initial"
                        hasArrow={false}
                        onClick={handleAddSpa}
                        isLoading={isLoading}
                        isDisabled={isDisabled}
                        testId={'spa-button-add-treatment'}
                    >
                        {isTablet ? (
                            <FormattedMessage
                                id="global.btn.add"
                                defaultMessage="Dodaj"
                            />
                        ) : (
                            <FormattedMessage
                                id="global.btn.add_to_order"
                                defaultMessage="Dodaj do zamówienia"
                            />
                        )}
                    </Button>
                </Box>
            </Box>
        </SummaryWrapper>
    )
}

export default Summary
